import {
  crfsCountPercentTranform,
  modifiedChartsAndSideCardData,
} from '../../../__utility__/crfsCountPercentTransform';
import { CHART_TYPES } from '../../../utility/constant';

function crfVerifiedTransform(data) {
  const countYAxisLabel = 'CRFs verified';
  const percentYAxisLabel = '% CRFs verified';
  const countChartDataKey = 'count';
  const percentChartDataKey = 'percentage';
  const countGroupColKey = 'count';
  const percentGroupColKey = 'percentage';
  const chartType = CHART_TYPES.SITES;

  const modifiedData = modifiedChartsAndSideCardData(
    data,
    chartType,
    countChartDataKey,
    percentChartDataKey,
  );

  return crfsCountPercentTranform(
    modifiedData,
    countYAxisLabel,
    percentYAxisLabel,
    countGroupColKey,
    percentGroupColKey,
  );
}

export default crfVerifiedTransform;
